import React, { Fragment } from "react";
import GenericApp from "../GenericApp";
import OrganizationAppForm from "./OrganizationAppForm";
import { useDispatch, useSelector } from "react-redux";
import GenericAppUtils from "../GenericApp/GenericAppUtils";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import { useIntl } from "react-intl";
import AttachFileIcon from "@material-ui/icons/Attachment";
import { ORGANIZATION_DESTROY, ORGANIZATION_STORE, ORGANIZATION_UPDATE } from "../../../redux/action-types/OrganizationActionTypes";
import FileUploaderActions from "../../../redux/sagas/actions/FileUploaderActions";

export const ORGANIZATION_FRONTEND_INDEX_URL = '/apps/organization';
export const ORGANIZATION_PAGINATE_URL = '/Organization/Paginate';
const NAME = 'organization';
const TITLE = 'Organization';
const SUBTITLE = 'App';
const ICON = <AttachFileIcon />;

function TenantApp(props) {

  const dispatch = useDispatch();
  const hist = useHistory();
  let { page, pageLimit } = useSelector(({ genericAppReducer }) => genericAppReducer);
  const intl = useIntl();

  const handleIndex = () => {
    hist.push(ORGANIZATION_FRONTEND_INDEX_URL);
  }

  const handleDestroy = (values) => {
    dispatch({type: ORGANIZATION_DESTROY, payload: values});
  };

  const handleSubmit = (values, formik) => {
    const type = values.id ?  ORGANIZATION_UPDATE : ORGANIZATION_STORE;
    dispatch({type: type, payload: values});
  };

  const AppSettings = {
    name: `${NAME}-app`,
    title: <IntlMessages id={TITLE} />,
    subTitle: SUBTITLE,
    searchTitle: intl.formatMessage({ id: 'Search...' }),
    notFoundTitle: <IntlMessages id={'No records found'} />,
    isCreate: true,
    isRead: true,
    isUpdate: true,
    isDelete: true,
    urls: {
      indexFrontend: ORGANIZATION_FRONTEND_INDEX_URL
    },
    createButton: {
      title: <IntlMessages id={'Create New'} />,
      icon: null
    },
    headers: [
      <IntlMessages id={'Name'} />,
      <IntlMessages id={'Id'} />,
      <IntlMessages id={'Alias'} />
    ],
    menuList: [
      {
        title: "Menu",
        items: [
          { id: 1, name: <IntlMessages id={TITLE} />, slug: `${NAME}-all`, icon: ICON, onClick: handleIndex }
        ]
      }
    ],
    recordMenuList: [
      {
        title: "Record Menu",
        items: [
          // { id: 1, name: "Users", slug: "users", icon: <GroupIcon />, onClick: (e) => console.log(e) }
        ]
      }
    ],
    dispatchActions: {
      paginate: GenericAppUtils.GetPaginateFunc(ORGANIZATION_PAGINATE_URL),
    },
    events: {
      onRenderTitle: (item) => (item.name),
      onRenderSubTitle: (item) => (item.email),
      onRenderAvatar: (item) => (FileUploaderActions.getDownloadImageUrl(item.profilePictureUrl, false)),
      onRenderExtraCells: (item) => ([item.id, item.alias]),
      onEditClick : (item) => console.log(item),
      onShowClick : (item) => console.log(item),
      onDeleteClick : handleDestroy,
      onDeleteMultiple : (items) => console.log(items),
      onCreateClick : (e) => console.log(e),
      onStarClick: null, //(item, status) => console.log(item, status),
      onSearchChange: null,//(s) => console.log(s),
      onSearchEnterKeyDown: null, //if this property is null, it will call the default search endpoint
    }
  };

  return (
    <Fragment>
      <GenericApp appSettings={AppSettings} form={<OrganizationAppForm onSubmit={handleSubmit}/>} isUseDialog={false} />
    </Fragment>
  );

}

export default TenantApp;
